import type { FirefliesListParams } from "@/types/fireflies";

export function buildFirefliesListParams(input: {
  limit?: number;
  skip?: number;
  search?: string;
  dateFrom?: string;
  dateTo?: string;
  scope?: FirefliesListParams["scope"];
}): FirefliesListParams {
  const params: FirefliesListParams = {
    limit: input.limit,
    skip: input.skip,
  };

  const dateFrom = input.dateFrom?.trim();
  const dateTo = input.dateTo?.trim();
  if (dateFrom) {
    params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
  }

  const keyword = input.search?.trim();
  if (keyword) {
    params.keyword = keyword;
    params.scope = input.scope ?? "ALL";
  }

  return params;
}

export function firefliesListParamsToSearchParams(
  params: FirefliesListParams
): URLSearchParams {
  const searchParams = new URLSearchParams();

  if (params.limit != null) searchParams.set("limit", String(params.limit));
  if (params.skip != null) searchParams.set("skip", String(params.skip));
  if (params.dateFrom) searchParams.set("dateFrom", params.dateFrom);
  if (params.dateTo) searchParams.set("dateTo", params.dateTo);
  if (params.keyword) searchParams.set("keyword", params.keyword);
  if (params.scope) searchParams.set("scope", params.scope);

  return searchParams;
}
